
import moment from "moment";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CancelButton from "../buttons/CancelButton.vue";
import DangerButton from "../buttons/DangerButton.vue";
import EditFrame from "../EditFrame.vue";
import { DeviceHardwareSettings } from "@/api/dtos/DeviceHardwareSettings.schema";
import { VestaWts04Address_v0_1 } from "@/api/dtos/VestaWts04Address_v0_1.schema";
import { VestaWts04OutAddress_v0_1 } from "@/api/dtos/VestaWts04OutAddress_v0_1.schema";
import { VestaWts04InAddress_v0_1 } from "@/api/dtos/VestaWts04InAddress_v0_1.schema";

@Component({
  components: {
    EditFrame,
    CancelButton,
    DangerButton,
  },
})
export default class DeviceHardwareSettingsForm extends Vue {
  @Prop()
  hardwareSettings!: DeviceHardwareSettings;

  @Prop({
    default: false,
  })
  hideControls!: boolean;

  @Prop({ default: false }) editMode!: boolean;

  wtsAddresses: VestaWts04Address_v0_1[] = [
    "WTS00",
    "WTS01",
    "WTS02",
    "WTS03",
    "WTS04",
    "WTS05",
    "WTS06",
    "WTS07",
    "WTS08",
    "WTS09",
    "WTS10",
    "WTS11",
    "WTS12",
    "WTS13",
    "WTS14",
    "WTS15"
  ];
  wtsOutPorts: VestaWts04OutAddress_v0_1[] = [
    "OUT1",
    "OUT2",
    "OUT3",
    "OUT4",
  ];
  wtsInPorts: VestaWts04InAddress_v0_1[] = [
    "IN1",
    "IN2",
    "IN3",
    "IN4",
  ];

  wts04OutAddress: VestaWts04Address_v0_1 = "WTS00";
  wts04OutPort: VestaWts04OutAddress_v0_1 = "OUT1";
  openDelayS = 0;
  openDurationS = 0;
  enableInput = false;
  wts04InAddress: VestaWts04Address_v0_1 = "WTS00";
  wts04InPort: VestaWts04InAddress_v0_1 = "IN1";
  alarmDelayS = 0;

  mounted(): void {
    this.importData();
  }

  @Watch("hardwareSettings")
  onDeviceHardwareSettingsSave(): void {
    this.importData();
  }

  importData(): void {
    this.wts04OutAddress = this.hardwareSettings.wts04Out.wts04;
    this.wts04OutPort = this.hardwareSettings.wts04Out.wts04OutPort;
    this.openDelayS = moment
      .duration(this.hardwareSettings.wts04Out.openDelay)
      .asSeconds();
    this.openDurationS = moment
      .duration(this.hardwareSettings.wts04Out.openDuration)
      .asSeconds();
    if (this.hardwareSettings.wts04In) {
      this.enableInput = true;
      this.wts04InAddress = this.hardwareSettings.wts04In.wts04;
      this.wts04InPort = this.hardwareSettings.wts04In.wts04InPort;
      this.alarmDelayS = moment
        .duration(this.hardwareSettings.wts04In.alarmDelay)
        .asSeconds();
    }
    else {
      this.enableInput = false;
      this.wts04InAddress = this.hardwareSettings.wts04Out.wts04;
      this.wts04InPort = this.equivalentInPort(this.hardwareSettings.wts04Out.wts04OutPort);
      this.alarmDelayS = 0;
    }
  }

  equivalentInPort(outPort: VestaWts04OutAddress_v0_1): VestaWts04InAddress_v0_1 {
    switch(outPort) {
      case "OUT1": return "IN1";
      case "OUT2": return "IN2";
      case "OUT3": return "IN3";
      case "OUT4": return "IN4";
      default: return "IN1";
    }
  }

  onInput(): void {
    const hardwareSettings: DeviceHardwareSettings = {
      hardwareType: this.hardwareSettings.hardwareType,
      wts04Out: {
        wts04: this.wts04OutAddress,
        wts04OutPort: this.wts04OutPort,
        openDelay: moment.duration(this.openDelayS, "seconds").toISOString(),
        openDuration: moment.duration(this.openDurationS, "seconds").toISOString(),
      },
      wts04In: !this.enableInput ? null : {
        wts04: this.wts04InAddress,
        wts04InPort: this.wts04InPort,
        alarmDelay: moment.duration(this.alarmDelayS, "seconds").toISOString(),
      },
    };

    this.$emit("input", hardwareSettings);
    console.log("hardwareSettings", hardwareSettings);
  }
}
